export default function PracticeElements(){
    
    
    let practiceElements = [
    
    {
    id: 1,    
    elType:"image",
    detail:  "https://images.unsplash.com/photo-1545405197-2964efafb2c6?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTF8fE1lbGJvdXJuZXxlbnwwfHwwfHx8MA%3D%3D&auto=format&fit=crop&w=800&q=60",
    zIndex: 0,
},

{
    id: 2,    
    elType:"image",
    detail:  "https://images.unsplash.com/photo-1545405197-2964efafb2c6?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTF8fE1lbGJvdXJuZXxlbnwwfHwwfHx8MA%3D%3D&auto=format&fit=crop&w=800&q=60",
    zIndex: 1,
},
{
    id: 3,    
    elType:"text",
    detail: "hello there",
    zIndex: 5,
},
{
    id: 4,    
    elType:"image",
    detail: "https://images.unsplash.com/photo-1545405197-2964efafb2c6?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTF8fE1lbGJvdXJuZXxlbnwwfHwwfHx8MA%3D%3D&auto=format&fit=crop&w=800&q=60",
    zIndex: 1,
},

{
    id: 5,    
    elType:"image",
    detail: "https://images.unsplash.com/photo-1514888286974-6c03e2ca1dba?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8Y2F0fGVufDB8fDB8fHww&auto=format&fit=crop&w=800&q=60",                     
    zIndex: 0,
},

{
    id: 6,    
    elType:"image",
    detail:"https://images.unsplash.com/photo-1600489601447-81ce0b723d44?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTJ8fGtpdHRlbnxlbnwwfHwwfHx8MA%3D%3D&auto=format&fit=crop&w=800&q=60",
    zIndex: 1,
},

{
    id: 7,    
    elType:"image",
    detail:"https://images.unsplash.com/photo-1600804340584-c7db2eacf0bf?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Nnx8cHVwcHl8ZW58MHx8MHx8fDA%3D&auto=format&fit=crop&w=800&q=60",
    zIndex: 2,
},

{
    id: 8,    
    elType:"image",
    detail:"https://images.unsplash.com/photo-1601979031925-424e53b6caaa?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8cHVwcHl8ZW58MHx8MHx8fDA%3D&auto=format&fit=crop&w=800&q=60",
    zIndex: 3,                  
},

{
    id: 9,    
    elType:"image",
    detail: "https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTF8fG1vdW50YWlufGVufDB8fDB8fHww&auto=format&fit=crop&w=800&q=60",                 
    zIndex: 2,
},

{
    id: 10,    
    elType:"image",
    detail:  "https://images.unsplash.com/photo-1512820790803-83ca734da794?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTZ8fGJvb2t8ZW58MHx8MHx8fDA%3D&auto=format&fit=crop&w=800&q=60",
    zIndex: 2,
},
{
    id: 11,    
    elType:"image",
    detail:  "https://images.unsplash.com/photo-1522012188892-24beb302783d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NDR8fGNvZmZlZXxlbnwwfHwwfHx8MA%3D%3D&auto=format&fit=crop&w=800&q=60",
    zIndex: 2,
},
{
    id: 12,    
    elType:"image",
    detail:  "https://images.unsplash.com/photo-1687800132770-8f1600a5849e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHx0b3BpYy1mZWVkfDEwfDZzTVZqVExTa2VRfHxlbnwwfHx8fHw%3D&auto=format&fit=crop&w=800&q=60",
    zIndex: 3,
},
  {
    id:13,
    elType:"text",
    detail: "Melbourne, my home",
    zIndex: 5,
  }

]
return practiceElements;
};
                                 
